import {Component, forwardRef, Inject} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {AddressService} from "./address.service";
import {AddressModel, addressModelFactory, addressModelFormGroup} from "./address.model";
import {FormGroup} from "@angular/forms";
import {exposeComponentInDebugMode} from "../misc/expose-component-in-debug-mode.decorator";
import {handleErrors} from "../misc/handle-errors.decorator";
import {get} from "lodash";

export interface ModifyAddressDialogParamsInterface {
  targetType: string;
  targetId: string;
}

export interface ModifyAddressDialogResultInterface {
  changed: boolean;
  address: AddressModel;
}

@Component({
  templateUrl: "./modify-address-dialog.template.pug",
})
@exposeComponentInDebugMode()
export class ModifyAddressDialogComponent
  extends DialogComponent<ModifyAddressDialogParamsInterface, ModifyAddressDialogResultInterface>
  implements ModifyAddressDialogParamsInterface {
  targetType: string;
  targetId: string;
  countryId: string;

  error: Error;
  addressForm: FormGroup = addressModelFormGroup();

  static showAddressModal(
    dialogService: DialogService,
    targetType: string,
    targetId: string,
  ): Promise<ModifyAddressDialogResultInterface> {
    return dialogService.showDialog(ModifyAddressDialogComponent, {targetType, targetId});
  }

  countryChanged() {
    this.countryId = get(this.addressForm, "controls.country.value");
  }

  @handleErrors()
  async submit() {
    const params = {type: this.targetType, id: this.targetId};
    let address = addressModelFactory(this.addressForm.value);

    address = await this.addressService.updateAddress(params, address);

    this.result.changed = true;
    this.result.address = address;
    this.addressForm = addressModelFormGroup(address);

    this.countryChanged();

    this.close();
  }

  @handleErrors()
  async loadData() {
    const address = await this.addressService.getAddress({type: this.targetType, id: this.targetId});

    if (!address.country) address.country = "";
    this.result.address = address;
    this.addressForm = addressModelFormGroup(address);

    this.countryChanged();
  }

  ready() {
    this.loadData();
  }

  constructor(
    public dialogService: DialogService,
    @Inject(forwardRef(() => AddressService)) private addressService: AddressService,
  ) {
    super(dialogService);
    this.result = {
      changed: false,
      address: addressModelFactory(),
    };
  }
}
